import { render, staticRenderFns } from "./customer-profit-detail.vue?vue&type=template&id=d5308f3e"
import script from "./customer-profit-detail.vue?vue&type=script&lang=js"
export * from "./customer-profit-detail.vue?vue&type=script&lang=js"
import style0 from "./customer-profit-detail.vue?vue&type=style&index=0&id=d5308f3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports